<div class="flex w-full flex-col rounded-lg bg-gray-5 py-5">
  <div class="flex items-center justify-between gap-4">
    <span class="text-lg font-semibold">{{ "Гарантації клієнта" }}</span>
    <button
      class="btn mb-3 bg-blue-primary px-4 py-1 text-sm text-white"
      (click)="navigateToMedicalServiceCreate()"
    >
      {{ "Створити нову" }}
    </button>
  </div>

  <div class="flex max-h-[57vh] flex-col overflow-y-auto overflow-x-hidden">
    @for (guarantee of filteredApplications(); track $index) {
      <div
        class="border-gray-3 py-4"
        [ngClass]="{ 'border-b-2': !$last }"
      >
        <div
          class="mb-2 flex cursor-pointer flex-col gap-1.5"
          (click)="navigateToMedicalServiceDetails(guarantee.id)"
        >
          <span>{{ guarantee.description }}</span>
          <span class="flex items-start gap-2 text-sm">
            {{ "Діагнози: " }}
            <shared-diagnosis
              [guarantee]="guarantee"
              [config]="{ showCoverageStatus: true, showProtocolLink: true }"
            ></shared-diagnosis>
          </span>
        </div>
        <ul class="ml-4 flex flex-col gap-2">
          @for (prescription of filterPrescriptions(guarantee); track $index) {
            <li class="flex items-center gap-3">
              <mat-icon class="text-blue-primary">
                @switch (prescription.type) {
                  @case (prescriptionTypes.Drugs) {
                    vaccines
                  }
                  @case (prescriptionTypes.InstrumentalDiagnostic) {
                    biotech
                  }
                  @case (prescriptionTypes.LaboratoryService) {
                    science
                  }
                  @default {
                    group
                  }
                }
              </mat-icon>
              <div class="flex flex-col">
                <span class="text-xs text-gray-2">
                  {{ "medicalServices.prescriptionTypes." + prescription.type | translate }}
                </span>
                <span
                  class="w-80 truncate text-sm"
                  [matTooltip]="prescription.name"
                >
                  {{ prescription.name }}
                </span>
              </div>

              <div class="ml-auto flex flex-col gap-0.5">
                <shared-status
                  [statusValue]="prescription.guaranteeStatus"
                  [statusMessage]="'statuses.guarantationStatuses.' + prescription.guaranteeStatus | translate"
                ></shared-status>
                <shared-status
                  [statusValue]="prescription.planningStatus"
                  [statusMessage]="'status.prescription.planning.' + prescription.planningStatus | translate"
                ></shared-status>
              </div>
            </li>
            @if (!$last) {
              <div class="h-[1px] w-full bg-gray-2"></div>
            }
          }
        </ul>
      </div>
    } @empty {
      <div class="text-center text-gray-2">Немає медичної історії</div>
    }
  </div>
</div>
